import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../auth.service';
import { catchError, exhaustMap, filter, first, map, takeUntil, tap } from 'rxjs/operators';
import * as fromLayout from '../../layout/state/layout.actions';
import { AppState } from '../../app.reducer';
import { Store } from '@ngrx/store';
import { RouterFacade } from '../../router/router.facade';
import { of } from 'rxjs';
import { SubscriptionDisposerComponent } from 'src/app/shared/disposer/subscription-disposer.component';

@Component({
  selector: 'app-auto-login',
  templateUrl: './auto-login.component.html',
  styleUrls: ['./auto-login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutoLoginComponent extends SubscriptionDisposerComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private store: Store<AppState>,
    private authService: AuthService,
    private routerFacade: RouterFacade,
  ) {
    super();
  }

  ngOnInit() {
    this.store.dispatch(fromLayout.StartLoading(null));
    this.routerFacade.routerQueryParams$
      .pipe(
        takeUntil(this.ngUnsubscribe),
        filter(routerQueryParams => routerQueryParams && routerQueryParams.token && routerQueryParams.email),
        first(),
        map(routerQueryParams => {
          const redirectPath = routerQueryParams.redirectToLocation ? [`/player/${routerQueryParams.redirectToLocation}`] : [`/locations`];
          return [routerQueryParams.token, routerQueryParams.email, redirectPath];
        }),
        exhaustMap(([token, email, redirectPath]) => this.authService.outdoorRefresh(token, email).pipe(
            tap(() => {
              this.routerFacade.go(redirectPath, {
                replaceUrl: true,
              });
            }),
            catchError(() => {
              this.store.dispatch(fromLayout.StopLoading());
              return of(this.routerFacade.go(['/login']));
            }),
          )),
      )
      .subscribe(() => {
        this.store.dispatch(fromLayout.StopLoading());
      });
  }
}
